import { Injectable } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { FoljaForma, FoljaFormaFjales, FoljaKoha, FoljaMenyra, FoljaNumri, FoljaVeta } from '@core/enums/folja.enum';
import { FoljaDeftore } from '@core/globals/folja/folja-deftore.constant';
import { FoljaConstants } from '@core/globals/folja/folja.constants';
import { FoljaDeftoreForCreationDTO } from '@core/interfaces/dto/folja-deftore-for-creation-dto.interface';
import { FoljaBaza } from '@core/interfaces/models/folja-baza.interface';
import { FoljaDeftoreFormulaService } from './folja-deftore-formula.service';

@Injectable({
  providedIn: 'root',
})
export class FoljaDeftoreService {
  constructor(private foljaDeftoreFormulaService: FoljaDeftoreFormulaService, private fb: UntypedFormBuilder) { }

  insertForms(foljaBaza: FoljaBaza, form: UntypedFormGroup) {
    let formArrays = ['foljaBaza.foljaDeftoreInitial', 'foljaBaza.foljaDeftore']

    for (let i = 0; i < formArrays.length; i++) {
      const formArray = form.get(formArrays[i]) as UntypedFormArray;
      this.generateDeftoreForms(formArray);
      foljaBaza.foljaDeftore?.forEach((item) => {
        let index = formArray.controls.findIndex(
          (c) =>
            c.get('kohaId')?.value == item.kohaId &&
            c.get('formaId')?.value == item.formaId &&
            c.get('vetaId')?.value == item.vetaId &&
            c.get('numriId')?.value == item.numriId &&
            c.get('formaFjalesId')?.value == item.formaFjalesId &&
            c.get('pershkrimi')?.value == '' &&
            c.get('renditja')?.value == item.renditja
        );
        if (index != -1) {
          formArray.controls[index].get('pershkrimi')!.setValue(item.pershkrimi);
        } else {
          this.addNewLakimi(formArray, item.kohaId, item.formaId, item.vetaId, item.numriId, item.formaFjalesId, item.pershkrimi, item.renditja);
        }
      });
    }
  }

  generateForms(formArray: UntypedFormArray) {
    this.generateDeftoreForms(formArray);
  }

  generateFormula(baza: string, foljaBaza: FoljaBaza, form: UntypedFormGroup) {
    const formArray = form.get('foljaBaza.foljaDeftore') as UntypedFormArray;
    this.foljaDeftoreFormulaService.generateFormula(baza, foljaBaza, formArray);
  }

  private generateDeftoreForms(formArray: UntypedFormArray) {
    while (formArray.length > 0) {
      formArray.removeAt(0);
    }

    for (const fk of FoljaDeftore.FoljaDeftoreKoha) {
      for (const ff of FoljaConstants.FoljaForma) {
        for (const fv of FoljaConstants.FoljaVeta) {
          for (const fn of FoljaConstants.FoljaNumri) {
            const foljaForm = this.fb.group({
              kohaId: fk.id,
              formaId: ff.id,
              vetaId: fv.id,
              numriId: fn.id,
              formaFjalesId: null,
              pershkrimi: '',
              renditja: 1
            });

            formArray.push(foljaForm);

            if (fk.id == FoljaKoha.ETashme || fk.id == FoljaKoha.EPakryer || fk.id == FoljaKoha.EKryerEThjeshte) {
              const foljaForm = this.fb.group({
                kohaId: fk.id,
                formaId: ff.id,
                vetaId: fv.id,
                numriId: fn.id,
                formaFjalesId: FoljaFormaFjales.cc,
                pershkrimi: '',
                renditja: 1
              });

              formArray.push(foljaForm);

              const foljaForm2 = this.fb.group({
                kohaId: fk.id,
                formaId: ff.id,
                vetaId: fv.id,
                numriId: fn.id,
                formaFjalesId: FoljaFormaFjales.s,
                pershkrimi: '',
                renditja: 1
              });

              formArray.push(foljaForm2);
            }
          }
        }
      }
    }
  }

  addNewLakimi(formArray: UntypedFormArray, koha: FoljaKoha, forma: FoljaForma, veta: FoljaVeta, numri: FoljaNumri, formaFjales: FoljaFormaFjales | null, pershkrimi?: string, renditja?: number) {
    const renditjet = formArray.value.filter((c: any) => c.kohaId == koha && c.formaId == forma && c.vetaId == veta && c.numriId == numri && c.formaFjalesId == formaFjales).map((c: any) => c.renditja);
    const prevIndex = Math.max(...(renditjet.length > 0 ? renditjet : [0]));
    const foljaForm = this.fb.group({
      kohaId: koha,
      formaId: forma,
      vetaId: veta,
      numriId: numri,
      formaFjalesId: formaFjales,
      pershkrimi: pershkrimi,
      renditja: renditja ?? prevIndex + 1
    });
    formArray.push(foljaForm);
  }

  getCreationDTO(form: UntypedFormGroup) {
    const creationDTO: FoljaDeftoreForCreationDTO[] = [];

    let formArray: UntypedFormArray;

    formArray = form.get('foljaBaza.foljaDeftore') as UntypedFormArray;

    const veproreParam = form.get('foljaBaza.veproreParam')?.value;
    const joveproreParam = form.get('foljaBaza.joveproreParam')?.value;
    const veproreNjejesParam = form.get('foljaBaza.veproreNjejesParam')?.value;
    const veproreShumesParam = form.get('foljaBaza.veproreShumesParam')?.value;
    const joveproreNjejesParam = form.get('foljaBaza.joveproreNjejesParam')?.value;
    const joveproreShumesParam = form.get('foljaBaza.joveproreShumesParam')?.value;

    let formArrayValue = formArray.getRawValue();

    if (!veproreParam) {
      formArrayValue = formArrayValue.filter((f: any) => f.formaId != FoljaForma.Veprore);
    } else {
      if (veproreNjejesParam) {
        formArrayValue = formArrayValue.filter(
          (f: any) =>
            f.formaId != FoljaForma.Veprore ||
            (f.numriId == FoljaNumri.Njejes && f.vetaId == FoljaVeta.Etrete) ||
            (veproreShumesParam && f.numriId == FoljaNumri.Shumes)
        );
      }
      if (veproreShumesParam) {
        formArrayValue = formArrayValue.filter(
          (f: any) =>
            f.formaId != FoljaForma.Veprore ||
            (f.numriId == FoljaNumri.Shumes && f.vetaId == FoljaVeta.Etrete) ||
            (veproreNjejesParam && f.numriId == FoljaNumri.Njejes)
        );
      }
    }
    if (!joveproreParam) {
      formArrayValue = formArrayValue.filter((f: any) => f.formaId != FoljaForma.JoVeprore);
    } else {
      if (joveproreNjejesParam) {
        formArrayValue = formArrayValue.filter(
          (f: any) =>
            f.formaId != FoljaForma.JoVeprore ||
            (f.numriId == FoljaNumri.Njejes && f.vetaId == FoljaVeta.Etrete) ||
            (joveproreShumesParam && f.numriId == FoljaNumri.Shumes)
        );
      }
      if (joveproreShumesParam) {
        formArrayValue = formArrayValue.filter(
          (f: any) =>
            f.formaId != FoljaForma.JoVeprore ||
            (f.numriId == FoljaNumri.Shumes && f.vetaId == FoljaVeta.Etrete) ||
            (joveproreNjejesParam && f.numriId == FoljaNumri.Njejes)
        );
      }
    }

    formArrayValue.forEach((e: any) => {
      creationDTO.push({
        kohaId: e.kohaId,
        formaId: e.formaId,
        vetaId: e.vetaId,
        numriId: e.numriId,
        formaFjalesId: e.formaFjalesId,
        pershkrimi: e.pershkrimi,
        renditja: e.renditja
      });
    });

    return creationDTO;
  }

  getErrors(foljaForm: UntypedFormGroup) {
    let errors: { menyraId: number; kohaId: number; formaId: number; vetaId: number; numriId: number; formaFjalesId: number | null; pershkrimi: string }[] = [];
    let initial = foljaForm.getRawValue().foljaDeftoreInitial;
    let formula = foljaForm.getRawValue().foljaDeftore;

    for (const fk of FoljaDeftore.FoljaDeftoreKoha) {
      for (const ff of FoljaConstants.FoljaForma) {
        for (const fv of FoljaConstants.FoljaVeta) {
          for (const fn of FoljaConstants.FoljaNumri) {
            let formatEFjales: any[] = [{ id: null }];

            if ([FoljaKoha.ETashme, FoljaKoha.EPakryer].includes(fk.id) || (fk.id == FoljaKoha.EKryerEThjeshte && ff.id == FoljaForma.Veprore)) {
              formatEFjales = formatEFjales.concat(FoljaConstants.FoljaFormatFjales);
            }

            for (const fff of formatEFjales) {
              const fmap = formula
                .filter((a: any) => a.kohaId == fk.id && a.formaId == ff.id && a.vetaId == fv.id && a.numriId == fn.id && a.formaFjalesId == fff.id)
                .map((a: any) => a.pershkrimi)
                .join(', ');

              const imap = initial
                .filter((a: any) => a.kohaId == fk.id && a.formaId == ff.id && a.vetaId == fv.id && a.numriId == fn.id && a.formaFjalesId == fff.id)
                .map((a: any) => a.pershkrimi)
                .join(', ');

              if (fmap != imap) {
                errors.push({
                  menyraId: FoljaMenyra.Deftore,
                  kohaId: fk.id,
                  formaId: ff.id,
                  vetaId: fv.id,
                  numriId: fn.id,
                  formaFjalesId: (fff != null ? fff.id : null),
                  pershkrimi: imap
                });
              }
            }
          }
        }
      }
    }

    return errors;
  }
}
